



























































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VAction, VHeaders } from '@/models/pagedlistmodel';
import { NotificationHelper as _notification } from '@/helper/notifications.helper';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { FileHelper as _file } from '@/helper/file.helper';
import {
  expenseService,
  attachmentService,
  storeService,
  repairOrderService,
} from '@/shared';

@Component({
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    AttachmentGrid: () =>
      import('@/components/repairorder/attachment.grid.vue'),
    SnackBarLoader: () => import('@/components/common/loader.vue'),
  },
})
class RoAttachmentReportPage extends Base {
  public loading: boolean = false;
  public attachmentsLoading: boolean = false;
  public attachmentLoader: boolean = false;
  public paginations = new PaginationModel('repairOrderNumber');
  public attachmentsPaginations = new PaginationModel('createdAt');
  public flags: any = {
    showForm: false,
    showAttachmentDetails: false,
    showEmailPopup: false,
    showCallGrid: true,
    showTextGrid: true,
    showAttachmentGrid: true,
  };
  public attachmentFilter: any = '';
  public attachmentFilters: any[] = [
    { value: 'RepairOrderNumber', text: 'RepairOrder Number' },
    { value: 'CustomerName', text: 'Customer Name' },
    { value: 'Vin', text: 'Vin' },
    { value: 'ServiceWriter', text: 'Service Writer' },
    { value: 'TagNumber', text: 'Tag Number' },

  ];

  public attachmentFilterForPlaceHolder: any[] = [
    { value: 'RepairOrderNumber', text: 'RO#' },
    { value: 'CustomerName', text: 'Customer' },
    { value: 'Vin', text: 'Vin' },
    { value: 'ServiceWriter', text: 'SVC Writer' },
    { value: 'TagNumber', text: 'Tag Number' },
  ];

  public showAttachmentGrid: boolean = false;

  public attachments = [];
  public attachmentDetails = [];

  public roAttachmentDialog: IDialogOption = {
    width: 1000,
    title: 'Ro Attachments',
    model: false,
    loading: false,
  };

  public headers: VHeaders[] = [];
  public attachmentHeaders: VHeaders[] = [];
  public actions: any[] = [];
  public attachmentActions: any[] = [];

  public setHeaders() {
    this.headers = [
      {
        align: 'left',
        sortable: true,
        text: 'RO#',
        value: 'repairOrderNumber',
      },
      {
        align: 'left',
        sortable: true,
        text: 'Customer',
        value: 'customerName',
      },
      {
        align: 'left',
        sortable: true,
        text: 'Last 8 VIN',
        value: 'vin',
        filters: [
          (val, item) => {
            return item.vin && item.vin.length > 10
              ? item.vin.substring(item.vin.length - 8, item.vin.length)
              : item.vin || 'N/A';
          },
        ],
      },
      {
        align: 'left',
        sortable: false,
        text: 'SVC Writer',
        value: 'serviceWriterName',
      },
      {
        align: 'left',
        sortable: false,
        text: 'Attachments Count',
        value: 'attachmentsCount',
        filters: [
          (val, item) => {
            return item.attachmentsCount == 0 ? 0 : item.attachmentsCount;
          },
        ],
      },
      {
        align: 'left',
        sortable: false,
        text: 'Scanned Count',
        value: 'scannedCount',
        filters: [
          (val, item) => {
            return item.scannedCount == 0 ? 0 : item.scannedCount;
          },
        ],
      },
      {
        text: 'Action',
        isNotDataProp: true,
        align: 'center',
        sortable: false,
      },
    ];

    this.attachmentHeaders = [
      {
        align: 'left',
        sortable: false,
        text: 'Attachment Type',
        value: 'attachmentTypeName',
      },
      {
        align: 'left',
        text: 'RO#',
        value: 'repairOrderId',
      },
      {
        align: 'left',
        sortable: false,
        text: 'User',
        value: 'userName',
      },
      {
        align: 'left',
        sortable: false,
        text: 'Comment',
        value: 'comment',
      },
      {
        align: 'left',
        sortable: false,
        text: 'Upload At',
        value: 'createdDateTime',
        fieldType: 'date',
      },
      {
        text: 'Actions',
        isNotDataProp: true,
        align: 'center',
        sortable: false,
      },
    ];
  }
  public setActions() {
    this.actions = [
      {
        type: 'button',
        icon: 'fa fa-paperclip',
        title: 'Attachments',
        loading: false,
        action: (model: any, action: VAction) => {
          this.showAttachmentDialog(model, action);
        },
      },
    ];

    this.attachmentActions = [
      {
        type: 'button',
        icon: 'fa fa-eye',
        title: 'View Attachment',
        loading: false,
        action: (model: any, action: VAction) => {
          this.viewAttachment(model.id, action);
        },
      },
    ];
  }

  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'roAttachmentReport');

    this.setActions();
    this.setHeaders();
    this.getRoAttachmentsReport();
  }

  public resetAttachmentsReport() {
    this.attachmentFilter = '';
    this.paginations.search = '';
    this.getRoAttachmentsReport();
  }

  public searchRoAttachmentsReport() {
    if (this.attachmentFilter == '') {
      this.showAlert(false, 'Please Select Filter By');
      return;
    }

    if (this.paginations.search == '') {
      this.showAlert(false, 'Please Enter a Value to Search');
      return;
    }
    this.paginations.page = 1;
    this.getRoAttachmentsReport();
  }

  public async getRoAttachmentsReport(): Promise<void> {
    try {
      this.loading = true;
      const attachment = await repairOrderService.getRoAttachmentsReport(
        this.paginations, this.attachmentFilter
      );
      this.attachments = attachment.results;
      this.paginations.totalItems = attachment.total;
    } finally {
      this.loading = false;
      this.flags.showAttachmentDetails = true;
    }
  }

  public async viewAttachment(
    attachmentId: string,
    action: any
  ): Promise<void> {
    try {
      action.loading = true;
      await attachmentService.viewAttachmentAsync(attachmentId);
    } finally {
      action.loading = false;
    }
  }

  public updatePaging(paging: PaginationModel) {
    this.getRoAttachmentsReport();
    this.paginations = paging;
  }

  public updateAttachmentDetailsPaging(paging: PaginationModel) {
    this.attachmentsPaginations = paging;
  }

  public async showAttachmentDialog(model: any, action: VAction) {
    // this.roAttachmentDialog.model = true;
    this.attachmentLoader = true;
    action.loading = true;
    try {
      this.attachmentsLoading = true;
      const attachmentDetails = await repairOrderService.getAttachmentDetails(
        model.repairOrderNumber,
        model.vin
      );
      this.attachmentDetails = attachmentDetails.results;
      this.attachmentsPaginations.totalItems = attachmentDetails.results.length;
    } finally {
      this.attachmentsLoading = false;
      action.loading = false;
      this.showAttachmentGrid = true;
      this.roAttachmentDialog.model = true;
      this.attachmentLoader = false;
    }
  }

  get attachmentSearchPlaceholder(): string {
  const selected = this.attachmentFilterForPlaceHolder.find(
    x => x.value === this.attachmentFilter
  );

  return selected
    ? `Search by ${selected.text}`
    : 'Search';
}
}
export default RoAttachmentReportPage;
